import React from 'react';
import PropTypes from 'prop-types';
import ClaimsTable from './ClaimsTable/ClaimsTable';
import ClaimsTableHeader from './ClaimsTable/ClaimsTableHeader';
import ClaimsTableRow from './ClaimsTable/ClaimsTableRow';
import { useClaimsShopSettings } from '../parcel-finder/ClaimsShopSettingsContext';

import './ClaimsCenterResults.scss';

function ClaimsCenterResults(props) {
  const {
    claims,
    onTakeActionButtonClick,
    onCancelClaimButtonClick,
    onContinueClaimSubmission,
    tableHeaderTop,
  } = props;
  const { isDORSigningLinkEnabled: showDorStatus } = useClaimsShopSettings();

  return (
    <div styleName="results">
      <ClaimsTable showDorStatus={showDorStatus}>
        <ClaimsTableHeader top={tableHeaderTop} />
        <tbody>
          {claims.map((claim) => (
            <ClaimsTableRow
              key={claim.id}
              claim={claim}
              onTakeActionButtonClick={onTakeActionButtonClick}
              onCancelClaimButtonClick={onCancelClaimButtonClick}
              onContinueClaimSubmission={onContinueClaimSubmission}
            />
          ))}
        </tbody>
      </ClaimsTable>
    </div>
  );
}

ClaimsCenterResults.propTypes = {
  claims: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      status: PropTypes.string,
      claimType: PropTypes.string,
      netValue: PropTypes.number,
      createdAt: PropTypes.string,
      trackingCode: PropTypes.string,
      shipmentId: PropTypes.number,
      netValueCurrency: PropTypes.string,
      tableHeaderTop: PropTypes.number,
    })
  ),
  onTakeActionButtonClick: PropTypes.func,
};

export default React.memo(ClaimsCenterResults);
